import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Index from "./pages/Home";
import ContactUs from "./pages/ContactUs";
import PP from "./pages/PrivacyPolicy";
import TermsofUse from "./pages/TermsofUse";
import ComplainPolicy from "./pages/ComplainPolicy";
import CookieBanner from "./components/cookie-banner/CookieBanner";
import SchemaComponent from "./components/universal/schema-component";
import { HelmetProvider } from "react-helmet-async";
import ReactGA from "react-ga4";
import { useEffect } from "react";
import Thankyou from "./pages/Thankyou";
function App() {
  const TRACKING_ID = "G-ZDN6BJSD2G";
  useEffect(() => {
    ReactGA.initialize(TRACKING_ID);
  }, []);
  return (
    <Router>
      <HelmetProvider>
        <SchemaComponent />
      </HelmetProvider>
      <CookieBanner />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/thank-you" element={<Thankyou />} />
        <Route path="/privacy-policy" element={<PP />} />
        <Route path="/terms-of-use" element={<TermsofUse />} />
        <Route path="/complain-policy" element={<ComplainPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;
